// @flow
export const OBTAINABLE_DESCRIPTIONS = {
  TA_REQUEST: 'Eseti légtér kérelem',
  CAA_PERMISSION: 'Az illetékes légiforgalmi szolgálat véleménye/hozzájárulása',
  MAA_PERMISSION: 'Az illetékes légiforgalmi szolgálat véleménye/hozzájárulása',
  TIZ_PERMISSION: 'Az illetékes légiforgalmi szolgálat véleménye/hozzájárulása',
  RA_USAGE: 'Engedély korlátozott légtér igénybevételére',
  ENV_USAGE:
    'Engedély környezetvédelmi szempontból korlátozott légtér igénybevételére',
  AIRPORT_NOTICE: 'Repülőtér nyilatkozata',
  SECURITY_SURVEY: 'Biztonsági felmérés',
};

export const UNAVAILABILITY_REASON_DESCRIPTIONS = {
  OVERLAPS_PROHIBITED_AREA:
    'A megadott koordináták átlapolnak egy tiltott légtérrel, amelyben a légiközlekedés tilos.',
  OVERLAPS_RESTRICTED_AREA:
    'A megadott koordináták átlapolnak egy korlátozott légtérrel, amelyben eseti légtér nem jelölhető ki.',
  OVERLAPS_TEMPORARY_AREA:
    'A megadott koordinátán és időpontban már van egy eseti légtér.',
  GEOMETRY_INVALID: 'A megrajzolt alakzat érvénytelen (metszi önmagát).',
  GEOMETRY_CROSSES_STATE_BORDER: 'Országhatáron kívül nem jelölhető ki légtér.',
  OVERLAPS_INVENTORY_ITEM:
    'Az igényelt légtér átfed egy már beadott igényléssel.',
};



// WEBPACK FOOTER //
// ./utils/results.js